import { Snackbar } from '@mui/material'
import { createContext, ReactNode, useContext, useState } from 'react'

type SnackbarText = string | undefined

interface SnackbarContextType {
  showSnackbar: (text: string) => void
}

const SnackbarContext = createContext<SnackbarContextType | undefined>(undefined)

export const SnackbarProvider = ({ children }: { children: ReactNode }) => {
  const [snackbarText, setSnackbarText] = useState<SnackbarText>(undefined)
  return (
    <SnackbarContext.Provider value={{ showSnackbar: setSnackbarText }}>
      {children}
      <Snackbar
        open={snackbarText != undefined}
        autoHideDuration={3000}
        onClose={() => {
          setSnackbarText(undefined)
        }}
        message={snackbarText}
      />
    </SnackbarContext.Provider>
  )
}

export const useSnackbar = () => {
  const context = useContext(SnackbarContext)
  if (!context) throw new Error('useSnackbarContext must be used within a SnackbarProvider')
  return context.showSnackbar
}
